export function getAgeFromDateString(dobStr: string): number {
	let dob: Date = new Date(dobStr)
	return Math.floor((Date.now() - dob.getTime()) / 31556952000) // .toString()
}